import React from "react";
import { Dialog, DialogContent, IconButton, Fade } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const ImagePreviewDialog = ({ open, image, title, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      TransitionComponent={Fade}
      PaperProps={{
        style: {
          background: "#111",
          overflow: "hidden",
          borderRadius: 12,
        },
      }}
    >
      <DialogContent
        style={{
          position: "relative",
          padding: 12,
          textAlign: "center",
          background: "#111",
        }}
      >
        <IconButton
          onClick={onClose}
          style={{
            position: "absolute",
            top: 6,
            right: 8,
            color: "#fff",
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {title && (
          <div
            style={{
              color: "#fff",
              marginBottom: 12,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            {title}
          </div>
        )}

        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            userSelect: "none",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
